<template>
    <div class="depoimentos">
            <div class="col-11 offset-1">
               <div id="tituloDepoimentos">
                   <h1 class="textoNossosServicos ml-4">Depoimentos dos nossos clientes</h1>
                </div>
           </div>
        <div class="mt-4">
            <a class="carousel-control-prev ml-4" href="#carouselExampleIndicators" role="button" data-slide="prev" id="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <div class="col-10 offset-1">
                <div class="row">
                    <div class="col-11 ml-4">
                        <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <div class="row mt-4">
                                        <div id="divInternaSlide" class="col-12">
                                            <div class="row ml-2">
                                                <div class="col-1 ml-4"><img src="~@/assets/imgs/quote.svg" class="mt-4 w-75 quote"></div>
                                                <div class="col-12">
                                                    <h1 class='tituloSlide'>O convênio com IEPTB-MT</h1>
                                                    <span class='textoSlide'>
                                                        veio para facilitar tanto para nos empresário como para os eventuais devedores; pois ganhamos tempo, diminuímos custos e facilitamos a vida do nosso cliente.
                                                    </span>
                                                </div>
                                                <div class="col-11 text-center mt-4">
                                                    <img src="~@/assets/imgs/testimony/daniel-moura.png" >
                                                    <p class="textoNome ml-4 mt-4"><b>Daniel de Moura Nogueira</b></p>
                                                    <p class="textoNome ml-4 ">Imobiliária Irmãos Nogueira</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row mt-4">
                                        <div id="divInternaSlide" class="col-12">
                                            <div class="row ml-2">
                                                <div class="col-1 ml-4"><img src="~@/assets/imgs/quote.svg" class="mt-4 w-75 quote"></div>
                                                <div class="col-12">
                                                    <h1 class='tituloSlide'>O convênio com IEPTB-GO</h1>
                                                    <span class='textoSlide'>
                                                        é um relevante instrumento para a Procuradoria-Geral do Estado assegurar eficiência na recuperação dos créditos não tributários do Estado de Goiás.
                                                    </span>
                                                </div>
                                                <div class="col-11 text-center mt-4">
                                                    <img src="~@/assets/imgs/testimony/ana-carolina.png" >
                                                    <p class="textoNome ml-4 mt-4"><b>Ana Carolina  S. Rios Chaer</b></p>
                                                    <p class="textoNome ml-4 ">Procuradora do Estado Gerente da Dívida Ativa</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row mt-4">
                                        <div id="divInternaSlide" class="col-12">
                                            <div class="row ml-2">
                                                <div class="col-1 ml-4"><img src="~@/assets/imgs/quote.svg" class="mt-4 w-75 quote"></div>
                                                <div class="col-12">
                                                    <h1 class='tituloSlide'>O convênio com IEPTB-PA</h1>
                                                    <span class='textoSlide'>
                                                        veio para facilitar tanto para nos empresário como para os eventuais devedores; pois ganhamos tempo, diminuímos custos e facilitamos a vida do nosso cliente.
                                                    </span>
                                                </div>
                                                <div class="col-11 text-center mt-4">
                                                    <img src="~@/assets/imgs/testimony/daniel-farias.png" >
                                                    <p class="textoNome ml-4 mt-4"><b>Daniel de Moura Nogueira</b></p>
                                                    <p class="textoNome ml-4 ">Imobiliária Irmãos Nogueira</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row mt-4">
                                        <div id="divInternaSlide" class="col-12">
                                            <div class="row ml-2">
                                                <div class="col-1 ml-4"><img src="~@/assets/imgs/quote.svg" class="mt-4 w-75 quote"></div>
                                                <div class="col-12">
                                                    <h1 class='tituloSlide'>O convênio com IEPTB-PA</h1>
                                                    <span class='textoSlide'>
                                                        auxilia o Poder Público para reaver seus créditos de modo ágil, transparente, econômico e seguro. Atendendo ao interesse público.
                                                    </span>
                                                </div>
                                                <div class="col-11 text-center mt-4">
                                                    <img src="~@/assets/imgs/testimony/rafael-mota.png" >
                                                    <p class="textoNome ml-4 mt-4"><b>Rafael Mota Queiroz</b></p>
                                                    <p class="textoNome ml-4 ">Procurador Fiscal da Prefeitura de Belém</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row mt-4">
                                        <div id="divInternaSlide" class="col-12">
                                            <div class="row ml-2">
                                                <div class="col-1 ml-4"><img src="~@/assets/imgs/quote.svg" class="mt-4 w-75 quote"></div>
                                                <div class="col-12">
                                                    <h1 class='tituloSlide'>Foi o achado - encontrar os Serviços do Instituto de Protesto - IEPTB/PB</h1>
                                                    <span class='textoSlide'>
                                                        Com o Cadastro muito prático: Protesto de cheques e Duplicadas sem intermediário(s): sem 'altas' despesas (tarifas) a pagar; de fácil acesso, através do navegador de internet; eficientes no atendimento pessoal - quando precisamos!
                                                    </span>
                                                </div>
                                                <div class="col-11 text-center mt-4">
                                                    <img src="~@/assets/imgs/testimony/manhattan-fomento-mercantil.png" >
                                                    <p class="textoNome ml-4 mt-4"><b>Alessandro Ayres</b></p>
                                                    <p class="textoNome ml-4 ">Gerente Operacional da Manhattan Fomento Mercantil</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next" id="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
        </a>   
         <ol class="carousel-indicators">
             <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
             &nbsp;&nbsp;&nbsp;&nbsp;
             <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
              &nbsp;&nbsp;&nbsp;&nbsp;
             <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <li data-target="#carouselExampleIndicators" data-slide-to="4"></li>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <li data-target="#carouselExampleIndicators" data-slide-to="5"></li>
         </ol>
    </div>
</template>
<script>
export default {
   
    
}
</script>
<style scoped>
.tituloCardDepoimentos{
    color: #69A9Fc;
    font-weight: bold;
    font-size: 16;
}
.textoNossosServicos
{
  color: #084f84;
  font-size: 29px;
  line-height: 25px;
  /* margin-right: 500px; */
  text-align: left;
  font-weight: bold;
}
@media (min-width: 900px) {
  .textoNossosServicos
  {
    color: #084f84;
    font-size: 35px;
    padding:2px;
    /* margin-right: 500px; */
    text-align: left;
  }
}
.depoimentos{
    margin-top: 80px;
    height:700px;
    background-color: rgb(239, 244, 250);
}
#tituloDepoimentos{
    margin-top: calc(5%);
}

@media (min-width: 900px) {
    #prev{
        margin-top: calc(10%);
    }
    #next{
        margin-top: calc(10%);
   }
}
.carousel-inner{
    height:600px;
}
#quote{
    margin-left: 50px;
}
#divInternaSlide{
    background:white;
    height:500px;
}
.tituloSlide{
    color:#084F84;
    font-size: 20px;
}
.textoSlide{
    color:#084F84;
    font-size: 15px;
}
.textoNome{
    color:#084F84;
    font-size: 13px;
}
.spacoP{
    line-height:10px;
}
.carousel-indicators li {
  width: 5px !important;
  height: 5px !important;
  border-radius: 50%;
  background-color: black;
}
</style>